import { FlagsBENL } from "@/components/Flags";

/**
 * Thin strip above the navbar — makes it instantly clear that the platform
 * serves both Belgian and Dutch customers, without screaming for attention.
 */
export default function TopStrip() {
  return (
    <div
      data-testid="top-strip"
      className="hidden sm:block bg-oc-primary text-white/90 text-[12px]"
    >
      <div className="oc-container h-8 flex items-center justify-between font-medium tracking-[0.01em]">
        <span className="inline-flex items-center gap-2">
          <FlagsBENL size="sm" />
          <span>Actief in <strong className="text-white">België</strong> &amp; <strong className="text-white">Nederland</strong></span>
        </span>
        <span className="hidden md:inline-flex items-center gap-5">
          <span className="text-white/75">Slimme offerte-analyse · vanaf € 4,99</span>
          <a
            href="mailto:info@offerteexpert.be"
            className="text-white/75 hover:text-white transition-colors"
          >
            info@offerteexpert.be
          </a>
        </span>
      </div>
    </div>
  );
}
